export const COMMON_LOADER_CONST = {
    tNamespace: "dialogs",
    tPath: {
        loading: "attachments.loading"
    }
}
